import type { ColumnDef, ScatterMapping } from '@deckspace/types';
import { rowsToColumnar, getColumn, defsByName, type Series } from '../shared/pivot.js';

export interface ScatterResult {
  labels: string[]; // generated point labels P1, P2, ...
  datasets: Series[]; // two datasets: x and y
}

export function prepScatterSeries(
  rows: Record<string, unknown>[],
  columnDefs: ColumnDef[],
  mapping: ScatterMapping
): ScatterResult {
  const tableData = rowsToColumnar(rows);
  const defs = defsByName(columnDefs);
  const labels = tableData.rows.map((_, i) => `P${i + 1}`);
  return {
    labels,
    datasets: [
      {
        label: mapping.xValues,
        values: getColumn<number>(tableData, mapping.xValues).map((v) => Number(v) || 0),
        type: defs[mapping.xValues]?.type ?? 'number',
        unit: defs[mapping.xValues]?.unit,
        currency: defs[mapping.xValues]?.currency,
      },
      {
        label: mapping.yValues,
        values: getColumn<number>(tableData, mapping.yValues).map((v) => Number(v) || 0),
        type: defs[mapping.yValues]?.type ?? 'number',
        unit: defs[mapping.yValues]?.unit,
        currency: defs[mapping.yValues]?.currency,
      },
    ],
  };
}
